import { AccountProfile, KeycloakUserInfo } from "core/types"

const claim = (value: string | undefined): string | null =>
  value?.trim() || null

export const toAccountProfile = (
  userInfo: KeycloakUserInfo
): AccountProfile => ({
  id: userInfo.sub,
  email: userInfo.email ?? "",
  firstName: userInfo.given_name ?? "",
  lastName: userInfo.family_name ?? "",
  preferredName: claim(userInfo.nickname) ?? "",
  dateOfBirth: claim(userInfo.birthdate),
  phoneNumber: claim(userInfo.phone_number),
})

export const fullName = (profile: AccountProfile): string =>
  [profile.firstName, profile.lastName].filter(Boolean).join(" ")

/**
 * Initials for the account avatar. Falls back to the email's first character
 * so the avatar is never blank for accounts with no name set.
 */
export const initials = (profile: AccountProfile): string => {
  const fromName = [profile.firstName, profile.lastName]
    .map((part) => part.trim().charAt(0))
    .filter(Boolean)
    .join("")

  const value = fromName || profile.email.trim().charAt(0)
  return value.toUpperCase()
}
